import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
// Create context to hold IP address and current date-time
const WaterMarkContext = createContext();

// Custom hook to fetch data from the API and update context state
const useWaterMarkData = () => {
  const [ip, setIP] = useState(null);
  const [currentDateTime, setCurrentDateTime] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userIp = await axios.get(
          `${process.env.REACT_APP_API_URL}water-mark`
        );
        setIP(userIp.data.ip_address);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();

    // const getUserIP = async () => {
    //   try {
    //     const res = await fetch("https://ipapi.co/json/");
    //     const data = await res.json();
    //     console.log("User IP:", data.ip);
    //     setIP(data.ip);
    //   } catch (err) {
    //     console.error("Failed to get IP:", err);
    //   }
    // };

    // getUserIP();

    const updateDateTime = () => {
      const date = new Date();
      const formattedDate = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      });
      const formattedTime = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
      setCurrentDateTime(`${formattedDate} ${formattedTime}`);
    };

    updateDateTime();
  }, []);

  return { ip, currentDateTime };
};

// Context provider to wrap around the component hierarchy
export const WaterMarkProvider = ({ children }) => {
  const waterMarkData = useWaterMarkData();

  return (
    <WaterMarkContext.Provider value={waterMarkData}>
      {children}
    </WaterMarkContext.Provider>
  );
};

// Custom hook to consume context data
export const useWaterMark = () => useContext(WaterMarkContext);
